import { render, staticRenderFns } from "./AdminNotifications.vue?vue&type=template&id=a6c7d582&scoped=true"
import script from "./AdminNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNotifications.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AdminNotifications.vue?vue&type=style&index=0&id=a6c7d582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c7d582",
  null
  
)

export default component.exports